/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Account } from './Account';
import {
    AccountFromJSON,
    AccountFromJSONTyped,
    AccountToJSON,
    AccountToJSONTyped,
} from './Account';
import type { Country } from './Country';
import {
    CountryFromJSON,
    CountryFromJSONTyped,
    CountryToJSON,
    CountryToJSONTyped,
} from './Country';
import type { Image } from './Image';
import {
    ImageFromJSON,
    ImageFromJSONTyped,
    ImageToJSON,
    ImageToJSONTyped,
} from './Image';

/**
 * 
 * @export
 * @interface Itinerary
 */
export interface Itinerary {
    /**
     * Unique identifier for the itinerary
     * @type {string}
     * @memberof Itinerary
     */
    readonly id: string;
    /**
     * Title of the itinerary - primary search field
     * @type {string}
     * @memberof Itinerary
     */
    title: string;
    /**
     * Short description of the itinerary
     * @type {string}
     * @memberof Itinerary
     */
    shortDescription: string;
    /**
     * URL of the itinerary image
     * @type {string}
     * @memberof Itinerary
     */
    imageUrl?: string;
    /**
     * Image entity with attribution details
     * @type {Image}
     * @memberof Itinerary
     */
    readonly image?: Image;
    /**
     * ID of the associated image entity
     * @type {string}
     * @memberof Itinerary
     */
    readonly imageId?: string;
    /**
     * Key highlights of the itinerary
     * @type {string}
     * @memberof Itinerary
     */
    highlights: string;
    /**
     * Detailed description of the itinerary
     * @type {string}
     * @memberof Itinerary
     */
    description: string;
    /**
     * Visibility of the itinerary
     * @type {string}
     * @memberof Itinerary
     */
    visibility: ItineraryVisibilityEnum;
    /**
     * Timestamp when the itinerary was created
     * @type {Date}
     * @memberof Itinerary
     */
    readonly createdAt: Date;
    /**
     * Timestamp when the itinerary was last updated
     * @type {Date}
     * @memberof Itinerary
     */
    readonly updatedAt: Date;
    /**
     * Number of stops associated with this itinerary
     * @type {number}
     * @memberof Itinerary
     */
    readonly stopsCount: number;
    /**
     * IDs of stops associated with this itinerary
     * @type {Array<string>}
     * @memberof Itinerary
     */
    readonly stopIds: Array<string>;
    /**
     * Number of days associated with this itinerary
     * @type {number}
     * @memberof Itinerary
     */
    readonly daysCount: number;
    /**
     * IDs of days associated with this itinerary
     * @type {Array<string>}
     * @memberof Itinerary
     */
    readonly dayIds: Array<string>;
    /**
     * Number of legs associated with this itinerary
     * @type {number}
     * @memberof Itinerary
     */
    readonly legsCount: number;
    /**
     * IDs of legs associated with this itinerary
     * @type {Array<string>}
     * @memberof Itinerary
     */
    readonly legIds: Array<string>;
    /**
     * 
     * @type {Account}
     * @memberof Itinerary
     */
    readonly account: Account;
    /**
     * 
     * @type {string}
     * @memberof Itinerary
     */
    readonly accountId: string;
    /**
     * 
     * @type {Array<Array<Country>>}
     * @memberof Itinerary
     */
    countries: Array<Array<Country>>;
    /**
     * IDs of countries where this itinerary takes place
     * @type {Array<string>}
     * @memberof Itinerary
     */
    readonly countryIds: Array<string>;
}


/**
 * @export
 */
export const ItineraryVisibilityEnum = {
    Draft: 'DRAFT',
    Public: 'PUBLIC',
    Private: 'PRIVATE'
} as const;
export type ItineraryVisibilityEnum = typeof ItineraryVisibilityEnum[keyof typeof ItineraryVisibilityEnum];


/**
 * Check if a given object implements the Itinerary interface.
 */
export function instanceOfItinerary(value: object): value is Itinerary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('shortDescription' in value) || value['shortDescription'] === undefined) return false;
    if (!('highlights' in value) || value['highlights'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('visibility' in value) || value['visibility'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('stopsCount' in value) || value['stopsCount'] === undefined) return false;
    if (!('stopIds' in value) || value['stopIds'] === undefined) return false;
    if (!('daysCount' in value) || value['daysCount'] === undefined) return false;
    if (!('dayIds' in value) || value['dayIds'] === undefined) return false;
    if (!('legsCount' in value) || value['legsCount'] === undefined) return false;
    if (!('legIds' in value) || value['legIds'] === undefined) return false;
    if (!('account' in value) || value['account'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('countries' in value) || value['countries'] === undefined) return false;
    if (!('countryIds' in value) || value['countryIds'] === undefined) return false;
    return true;
}

export function ItineraryFromJSON(json: any): Itinerary {
    return ItineraryFromJSONTyped(json, false);
}

export function ItineraryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Itinerary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'shortDescription': json['shortDescription'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'image': json['image'] == null ? undefined : ImageFromJSON(json['image']),
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'highlights': json['highlights'],
        'description': json['description'],
        'visibility': json['visibility'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'stopsCount': json['stopsCount'],
        'stopIds': json['stopIds'],
        'daysCount': json['daysCount'],
        'dayIds': json['dayIds'],
        'legsCount': json['legsCount'],
        'legIds': json['legIds'],
        'account': AccountFromJSON(json['account']),
        'accountId': json['accountId'],
        'countries': json['countries'],
        'countryIds': json['countryIds'],
    };
}

  export function ItineraryToJSON(json: any): Itinerary {
      return ItineraryToJSONTyped(json, false);
  }

  export function ItineraryToJSONTyped(value?: Omit<Itinerary, 'id'|'image'|'imageId'|'createdAt'|'updatedAt'|'stopsCount'|'stopIds'|'daysCount'|'dayIds'|'legsCount'|'legIds'|'account'|'accountId'|'countryIds'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'shortDescription': value['shortDescription'],
        'imageUrl': value['imageUrl'],
        'highlights': value['highlights'],
        'description': value['description'],
        'visibility': value['visibility'],
        'countries': value['countries'],
    };
}

